import { useToast } from "@expert/common-ui";
import { Button, Tooltip, useMatches } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import classes from "./WorkspaceHeader.module.css";

/**
 * Button to display and copy the current session ID to clipboard.
 * Shows different text layouts and tooltips based on screen size.
 */
export function SessionIdCopyButton({ sessionId }: { sessionId: string }) {
    const clipboard = useClipboard({ timeout: 500 });
    const toast = useToast();

    const displaySessionId = useMatches({
        lg: `Session ID: ${sessionId}`,
        md: sessionId,
        base: `${sessionId.slice(0, 8)}...`,
    });

    const tooltipLabel = useMatches({
        lg: "Click to copy",
        md: `Click to copy session ID`,
        base: `Click to copy session ID: ${sessionId}`,
    });

    const copyToClipboard = () => {
        clipboard.copy(sessionId);
        toast.success("Session ID copied to clipboard");
    };

    const button = (
        <Button
            variant="transparent"
            onClick={copyToClipboard}
            className={classes.sessionIdText}
            size="xs"
            fz="xs"
            aria-label={`Copy session ID: ${sessionId}`}
        >
            {displaySessionId}
        </Button>
    );
    return (
        <Tooltip label={tooltipLabel} zIndex="var(--mantine-priority-highest)">
            {button}
        </Tooltip>
    );
}
